var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "searchpage-container" }, [
    _c("div", { staticClass: "search-container searchpage" }, [
      _c("div", { staticClass: "search-box" }, [
        _c(
          "div",
          { staticClass: "input-container input-group input-group-lg" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query,
                  expression: "query",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Zoeken",
                "aria-label": "Large",
                "aria-describedby": "inputGroup-sizing-sm",
              },
              domProps: { value: _vm.query },
              on: {
                change: _vm.executeSearch,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.query = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-transparent",
                  attrs: { type: "button" },
                },
                [
                  _c("svg", { staticClass: "icon icon-arrow--right" }, [
                    _c("use", {
                      attrs: { "xlink:href": "#icon-arrow--right" },
                    }),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search-result" }, [
      _c("div", { staticClass: "container-xl" }, [
        _c("div", { staticClass: "row d-flex justify-content-center" }, [
          _c("div", { staticClass: "col-3" }, [
            _c(
              "ul",
              { staticClass: "search-results-categories" },
              _vm._l(_vm.categories, function (item) {
                return _c(
                  "li",
                  {
                    key: item.Category,
                    staticClass: "category",
                    class: { active: item.Category == _vm.filter },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function ($event) {
                            return _vm.setFilter(item.Category)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(item.Category) +
                            " (" +
                            _vm._s(item.Amount) +
                            ")\n                            "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _vm.items.length > 0
            ? _c(
                "div",
                { staticClass: "col-7" },
                _vm._l(_vm.filteredItems, function (item) {
                  return _c(
                    "a",
                    {
                      key: item.id,
                      staticClass: "search-results-item",
                      attrs: { href: item.url },
                    },
                    [
                      item.category
                        ? _c(
                            "ul",
                            { staticClass: "category-list" },
                            _vm._l(item.category, function (category) {
                              return _c(
                                "li",
                                { staticClass: "item-category" },
                                [_vm._v(_vm._s(category))]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h4", { staticClass: "item-title" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "item-description",
                        domProps: { innerHTML: _vm._s(item.summary) },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.date))]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "col-7" }, [
                _c("h3", [_vm._v(_vm._s(_vm.noResultsTitle))]),
                _vm._v(" "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.content.noResultsContent) },
                }),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.visibleItems < _vm.filteredItemsLength &&
          _vm.filteredItemsLength > 12
            ? _c(
                "div",
                {
                  staticClass:
                    "loadmore d-flex justify-content-center align-items-center",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-general roll-button rollover",
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function ($event) {
                          return _vm.loadMore(12)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "roll-text" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.content.loadMoreLabel) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "roll-text" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.content.loadMoreLabel) +
                            "\n                        "
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }